import { formatLine } from '../../utils/odds'
import { escapeRegExp, isSpreadLeg } from '../../../../../shared/pkg/prepacks/templateRendering.js'

// A leg is a Prepacks leg (models.PrepackLeg): the shape every leg search
// returns and Prepacks persists.

// isSpreadLeg and the spread keys live with the card renderer (shared with
// the widget); the API's spreadMarketKeys (services/selection_line.go) is the
// same set.
export { isSpreadLeg }

/**
 * `text` as a whole word, so "7" is not found in "49ers", "7+" or "7.5". A word
 * may open with "(" or "[" and close with ")", "]" or ",", as the API's
 * selectionLineTokenIndex reads one.
 */
const wordPattern = (text) => new RegExp(`(^|\\s|[([])${escapeRegExp(text)}(?=$|\\s|[)\\],])`)

/**
 * The selection as players read it: "Over 48.5", "Kansas City Chiefs",
 * "Cincinnati Bengals +7". A handicap's positive line is signed, also in a
 * name saved before Studio signed it ("Cincinnati Bengals 7").
 */
export function legLabel(leg) {
  const name = String(leg?.selection_name || leg?.participant || '').trim()
  const line = formatLine(leg?.line, { signed: isSpreadLeg(leg) })
  let label = name
  if (line && !name.includes(line)) {
    const unsigned = line.startsWith('+') ? line.slice(1) : ''
    const legacy = unsigned && wordPattern(unsigned)
    label = legacy && legacy.test(name) ? name.replace(legacy, `$1${line}`) : `${name} ${line}`.trim()
  }
  return label || String(leg?.market_label || 'Selection')
}

/**
 * Picking a selected leg again removes it; a new leg is added unless the
 * selection already holds `max` legs, which is rejected as 'max'.
 */
export function toggleLeg(legs, leg, { max = Infinity } = {}) {
  const id = String(leg.outcome_id)
  if (legs.some((item) => String(item.outcome_id) === id)) {
    return { legs: legs.filter((item) => String(item.outcome_id) !== id), rejection: null }
  }
  if (legs.length >= max) return { legs, rejection: 'max' }
  return { legs: [...legs, leg], rejection: null }
}
